import {
  CHECKOUT_LOAD_DATA,
  SET_IS_SENDING,
  UPDATE_ADDRESS,
  UPDATE_UNLOADING_POINT,
} from "../actions/checkoutPageActions";
import { type TransformedCheckoutData } from "../../transformers/CheckoutViewDataTransformer";
import { type ActionType } from "../../../redux/types";
import { type AddressData, type UnloadingPointData } from "../../components/CheckoutPage/Address";
import { type CheckoutPageStore, initialCheckoutPageState } from "../types";

const pageReducer = (state = initialCheckoutPageState, action: ActionType<{}>): CheckoutPageStore => {
  switch (action.type) {
    case CHECKOUT_LOAD_DATA: {
      const { data } = action.payload as {
        data: TransformedCheckoutData;
      };

      const defaultAddress = data.addresses.filter((address) => address.default)[0];

      const unloadingPoints = data.deliveryAddress?.parentUnit
        ? data.unloadingPoints?.[data.deliveryAddress.parentUnit]
        : undefined;
      const unloadingPoint = unloadingPoints?.find((item) => item.selected) ?? unloadingPoints?.[0] ?? undefined;

      return {
        ...state,
        accountNumber: data.accountNumber,
        addresses: data.addresses,
        soldTo: data.soldTo,
        selectedAddress: data.deliveryAddress,
        countriesList: data.countriesList,
        canAddAddress: data.canAddAddress,
        unloadingPoints: data.unloadingPoints,
        loading: false,
        unloadingPoint: unloadingPoint,
        defaultCreditCard: data.defaultCreditCard,
        supportedPaymentTypes: data.supportedPaymentTypes,
        orderablePackageIds: data.orderablePackageIds,
        quotablePackageIds: data.quotablePackageIds,
      };
    }

    case UPDATE_ADDRESS: {
      const newAddress = action.payload as AddressData;

      const unloadingPoints = newAddress?.parentUnit ? state.unloadingPoints?.[newAddress.parentUnit] : undefined;
      const unloadingPoint = unloadingPoints?.find((item) => item.selected) ?? unloadingPoints?.[0] ?? undefined;

      return {
        ...state,
        selectedAddress: newAddress,
        unloadingPoint: unloadingPoint,
      };
    }

    case UPDATE_UNLOADING_POINT: {
      const newUnloadingPoint = action.payload as UnloadingPointData;
      return {
        ...state,
        unloadingPoint: newUnloadingPoint,
      };
    }

    case SET_IS_SENDING: {
      const isSending = action.payload as boolean;

      return {
        ...state,
        sending: isSending,
      };
    }

    default:
      return state;
  }
};

export const checkoutPageReducer = pageReducer;
